angular.module('tgaAdmin')
  .service('hubService', [
    '$http', '$location', 'envService', 'domainService', 'urlService', 'authService',
    function (
      $http, $location, envService, domainService, urlService, authService,
    ) {
      const serverAddress = envService.read('serverAddress');
      let hub = {};

      function getHub(hubId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/${hubId}`,
        }).then(
          (response) => {
            hub = response.data;
            return response.data;
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function currentHub() {
        return hub;
      }

      function getHubs(params = {}) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addHub(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}hub`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function copyHub(hub_id) {
        return $http({
          method: 'POST',
          url: `${serverAddress}hub/copy`,
          data: {
            hub_id,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function archiveHub(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/archive/${data.hub_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getArchivedHubs(params = {}) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub`,
          params: {
            is_archived: true,
            ...params,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteHub(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/delete/${data.hub_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateHub(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/${data.hub_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateTheme(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}hub/theme/${data.hub_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCourse(courseId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/course/${courseId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCourses() {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/course`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addCourse(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}hub/course`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteCourse(courseId) {
        return $http({
          method: 'DELETE',
          url: `${serverAddress}hub/course/${courseId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateCourse(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/course/${data.course_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getActivityStats(hubId, startDate, endDate, additionalParams) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/activity/stats`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
            ...additionalParams,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getPagedActivityStats(params = {}) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/activity/stats`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getTotalPlayers(hubId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/player/total`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getNewPlayers(hubId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/player/new`,
          params: {
            hub_id: hubId,
            user_type: 'player',
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getSessionStats(hubId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/session`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getSessionsReport(hubId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/session_report`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getPlayers(hubId, startDate, endDate, extended) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/player`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
            extended,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getPagedPlayers(params = {}) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/player`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getPrizes(hubId, startDate, endDate, extended) {
        return $http({
          method: 'GET',
          url: `${serverAddress}prize`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
            extended,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updatePrizes(hubId, prizesName, prizesEnabled, changedPrizes) {
        return $http({
          method: 'POST',
          url: `${serverAddress}prize`,
          data: {
            hub_id: hubId,
            prizes_title: prizesName,
            prizes_enabled: prizesEnabled,
            prizes: changedPrizes,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getHubPrizes(hubId, startDate, endDate, extended) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/prize/stats`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
            extended,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getPagedHubPrizes(params = {}) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/prize/stats`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getTotalSteps(hubId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/steps`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getPlayer(hubId, userId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/player/${userId}`,
          params: {
            hubId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updatePlayer(data) {
        data.hub_id = hub.hub_id;

        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/player`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getChallengeStats(hubId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}challenge/stats`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getHubSpinData(hubId, startDate, endDate) {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/spin/data`,
          params: {
            hub_id: hubId,
            start_date: startDate,
            end_date: endDate,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getHubUrl(h) {
        return `${urlService.composeProtocolHostPort($location)}/arcade/${h.slug}`;
      }

      function getRegistration() {
        return $http({
          method: 'GET',
          url: `${serverAddress}hub/registration/${hub.hub_id}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addRegistration(data) {
        data.hub_id = hub.hub_id;

        return $http({
          method: 'POST',
          url: `${serverAddress}hub/registration`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function uploadRegistration(file) {
        return $http({
          method: 'POST',
          url: `${serverAddress}hub/registration/upload`,
          // IMPORTANT!!! You might think this should be set to 'multipart/form-data'
          // but this is not true because when we are sending up files the request
          // needs to include a 'boundary' parameter which identifies the boundary
          // name between parts in this multi-part request and setting the Content-type
          // manually will not set this boundary parameter. For whatever reason,
          // setting the Content-type to 'false' will force the request to automatically
          // populate the headers properly including the boundary parameter.
          headers: { 'Content-Type': undefined },
          // This method will allow us to change how the data is sent up to the server
          // for which we'll need to encapsulate the farmer data in 'FormData'
          transformRequest(data) {
            const formData = new FormData();
            formData.append('hub_id', hub.hub_id);
            formData.append('file', data.file);
            return formData;
          },
          data: {
            hub_id: hub.hub_id,
            file,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateRegistrationSettings(data) {
        data.hub_id = hub.hub_id;

        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/registration/settings`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateRegistrationFields(data) {
        data.hub_id = hub.hub_id;

        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/registration/fields`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function sendInvitation(user_id) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}hub/invitation`,
          data: {
            hub_id: hub.hub_id,
            user_id,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getJourneys(data) {
        if (!data.course_group_type) {
          data.course_group_type = 1; // COURSE_GROUP_TYPE_JOURNEY
        }
        return $http({
          method: 'GET',
          url: `${serverAddress}journey`,
          params: data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addJourney(d) {
        if (!d.journey.course_group_type) {
          d.journey.course_group_type = 1; // COURSE_GROUP_TYPE_JOURNEY
        }
        d.hub_id = hub.hub_id;
        return $http({
          method: 'POST',
          url: `${serverAddress}journey`,
          headers: { 'Content-Type': undefined },
          data: d,
          // This method will allow us to change how the data is sent up to the server
          // for which we'll need to encapsulate the farmer data in 'FormData'
          transformRequest(data) {
            const formData = new FormData();
            formData.append('data', angular.toJson(data));

            for (let i = 0; i < data.journey.courses.length; i++) {
              for (let j = 0; j < data.journey.courses[i].items.length; j++) {
                if (data.journey.courses[i].items[j].file && data.journey.courses[i].items[j].file.file) {
                  const key = `file-${i}-${j}`;
                  formData.append(key, data.journey.courses[i].items[j].file.file);
                }

                if (data.journey.courses[i].items[j].tile_image_file && data.journey.courses[i].items[j].tile_image_file.file) {
                  const key = `tile-${i}-${j}`;
                  formData.append(key, data.journey.courses[i].items[j].tile_image_file.file);
                }
              }
            }
            return formData;
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function editJourney(courseGroupId, d) {
        d.hub_id = hub.hub_id;

        return $http({
          method: 'POST',
          url: `${serverAddress}journey/${courseGroupId}`,
          headers: { 'Content-Type': undefined },
          data: d,
          // This method will allow us to change how the data is sent up to the server
          // for which we'll need to encapsulate the farmer data in 'FormData'
          transformRequest(data) {
            const formData = new FormData();
            formData.append('data', angular.toJson(data));

            for (let i = 0; i < data.journey.courses.length; i++) {
              for (let j = 0; j < data.journey.courses[i].items.length; j++) {
                if (data.journey.courses[i].items[j].file && data.journey.courses[i].items[j].file.file) {
                  const key = `file-${i}-${j}`;
                  formData.append(key, data.journey.courses[i].items[j].file.file);
                }

                if (data.journey.courses[i].items[j].tile_image_file && data.journey.courses[i].items[j].tile_image_file.file) {
                  const key = `tile-${i}-${j}`;
                  formData.append(key, data.journey.courses[i].items[j].tile_image_file.file);
                }
              }
            }

            return formData;
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteJourney(courseGroupId) {
        return $http({
          method: 'POST',
          url: `${serverAddress}journey/delete`,
          data: {
            hub_id: hub.hub_id,
            course_group_id: courseGroupId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getMissions(data) {
        if (!data.course_group_type) {
          data.course_group_type = 2; // COURSE_GROUP_TYPE_MISSION
        }
        return getJourneys(data);
      }

      function addMission(data) {
        if (!data.journey.course_group_type) {
          data.journey.course_group_type = 2; // COURSE_GROUP_TYPE_MISSION
        }
        return addJourney(data);
      }

      function editMission(courseGroupId, data) {
        return editJourney(courseGroupId, data);
      }

      function deleteMission(courseGroupId) {
        return deleteJourney(courseGroupId);
      }

      function getLeaderboard(data) {
        data = data || {};
        data.hub_id = hub.hub_id;

        return $http({
          method: 'GET',
          url: `${serverAddress}hub/leaderboard`,
          params: data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getScormUrl(hubId, version) {
        // eslint-disable-next-line max-len
        return `${serverAddress}hub/scorm/${hubId}/?X-TGA-KEY=${authService.getAuthentication().token}&X-DEVICE-KEY=${authService.getDeviceToken()}&domain=${domainService.domain}&version=${version}`;
      }

      function getTaskTypes() {
        return [
          {
            key: 'pdf',
            name: 'PDF',
          }, {
            key: 'image',
            name: 'Image',
          }, {
            key: 'video',
            name: 'Video',
          }, {
            key: 'link',
            name: 'URL',
          }, {
            key: 'audio',
            name: 'Audio',
          },
        ];
      }

      function publishToDocebo(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}hub/docebo`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getHub,
        currentHub,
        getHubs,
        addHub,
        copyHub,
        archiveHub,
        getArchivedHubs,
        deleteHub,
        updateHub,
        updateTheme,
        getActivityStats,
        getPagedActivityStats,
        getChallengeStats,
        getCourse,
        getCourses,
        addCourse,
        deleteCourse,
        updateCourse,
        getTotalPlayers,
        getNewPlayers,
        getSessionStats,
        getSessionsReport,
        getPlayers,
        getPagedPlayers,
        getPlayer,
        updatePlayer,
        getPrizes,
        updatePrizes,
        getHubPrizes,
        getPagedHubPrizes,
        getTotalSteps,
        getHubSpinData,
        getHubUrl,
        getRegistration,
        addRegistration,
        uploadRegistration,
        updateRegistrationSettings,
        updateRegistrationFields,
        sendInvitation,
        getJourneys,
        addJourney,
        editJourney,
        deleteJourney,
        getMissions,
        addMission,
        editMission,
        deleteMission,
        getLeaderboard,
        getScormUrl,
        getTaskTypes,
        publishToDocebo,
      });
    }]);
